<template>
    <div class="SocietyDashMatchContainer shadow">
        <div class="SocietyDashMatchContainer-img">
            <img :src="matchLogo(match.competizione)" alt="logo"/>
        </div>
        <div class="SocietyContactContainer-info">
            <div class="text-uppercase">{{match.opponent}} <small class="text-primary">{{competition}}</small></div>
            <div class="text-uppercase">Data: {{match.date | date}}</div>
            <div class="text-uppercase small mt-2">
                Date: <span class="text-success">{{match.start_request | date}}</span> -
                <span class="text-danger">{{match.end_request | date}}</span>
            </div>
            <div class="text-uppercase mt-2">Prezzo: {{match.price | currency}}</div>
            <inter-button class="mt-2"
                          size="small"
                          label="RICHIEDI"
                          @onClick="$router.push({name: 'society.matches.wizard'})">
            </inter-button>
        </div>
    </div>
</template>

<script>

    import Match from '@/models/Match';
    import InterButton from "../../../../components/form/inter-button/InterButton";
    import MatchService from "@/services/match-service";

    export default {
        name: "SocietyDashMatchContainer",
        components: {InterButton},
        props: {
            match: {
                type: Object,
                default: () => Object.assign({}, Match)
            },
        },
        data() {
            return {
                srcLogo: require('@/assets/media/logo.svg'),
            }
        },
        methods: {
            matchLogo: function (competition) {
                return MatchService.getCompetitionLogo(competition)

            },
        },
        computed: {
            competition: function() {
                if(this.match && this.match.archivioPartita && this.match.archivioPartita.competition ) {
                    return this.match.archivioPartita.competition.name;
                } else {
                    return '';
                }
            }
        },
    }
</script>

<style scoped>

</style>
